export default __webpack_public_path__ + "static/media/headerDesktopBackgroud.21a2b6e3.svg";